import AppLinkComponent, { AppLinkProps } from "@/components/AppLink";
import BackButtonComponent from "@/components/BackButton";

// Cast to fix React 17 + @types/react 18 compatibility issue
const AppLink = AppLinkComponent as any;
const BackButton = BackButtonComponent as any;

export type InternalLinkProps = AppLinkProps & {
  _type: "internalLink";
};

const InternalLink: React.FC<InternalLinkProps> = (props) => {
  const { title, page, params } = props;

  return (
    <AppLink page={page} params={params}>
      <BackButton>{title || undefined}</BackButton>
    </AppLink>
  );
};

export default InternalLink;
